import React, {Component} from "react";
import PriceItem from "../../common/PriceItem";
import CoreService from "../../service/CoreService";

class PriceList extends Component {
    contactPopup = () => {
        CoreService.showModal('Enterprise plan', (
            <span>Please contact us at <a href="mailto:info@gatehillsoftware.com">info@gatehillsoftware.com</a> to find out more.</span>
        ));
    };

    render() {
        return (
            <div className="container text-center">

                <div className="row">
                    <PriceItem
                        title="Starter"
                        description="Entry level plan for a small job. This one's on us."
                        price="0"
                        limitColumns={4}
                        features={[
                            <span><strong>20</strong> monthly deployments</span>,
                            <span className="text-muted">no build history</span>,
                            <span className="text-muted">no logs</span>
                        ]}
                        buttonText={<span>Create <span
                            className="visible-lg-inline">a free account</span></span>}
                        buttonStyle="primary"
                        onClick={() => CoreService.navigateTo('/register')}
                    />

                    <PriceItem
                        title="Individual"
                        description="The perfect size for a single project."
                        price="3"
                        limitColumns={4}
                        features={[
                            <span><strong>1,000</strong> monthly deployments</span>,
                            <span><strong>history</strong> of your builds</span>,
                            <span><strong>logs</strong> in real-time</span>
                        ]}
                        buttonText={<span>Create <span
                            className="visible-lg-inline">an individual account</span></span>}
                        buttonStyle="primary"
                        onClick={() => CoreService.navigateTo('/register')}
                    />

                    <PriceItem
                        title="Enterprise"
                        description="A plan for larger teams, with plenty of room to grow."
                        price="99"
                        limitColumns={4}
                        features={[
                            <span><strong>unlimited</strong> deployments</span>,
                            <span><strong>all</strong> individual plan features</span>,
                            <span><strong>team</strong> accounts</span>
                        ]}
                        buttonText="Learn more"
                        buttonStyle="warning"
                        onClick={this.contactPopup}
                    />

                </div>
            </div>
        );
    }
}

export default PriceList;



// WEBPACK FOOTER //
// ./src/modules/views/common/PriceList.js